module.exports = __webpack_public_path__ + "static/media/silence.mp3?4665c53176adc95a6f2f556ec2c4d735";